export default {
  v3SubmitErrBtnViewOrder: 'View Order',
  v3SubmitErrBtnBackHome: 'Home',
  v3SubmitErrBtnRetry: 'Retry',
  v3SubmitErrBtnRelogin: 'Re-login',
  v3SubmitErrBtnSwitchPay: 'Switch Payment',
  v3SubmitErrBtnReorder: 'Reorder',
  v3SubmitErrBtnSwitchServer: 'Switch Server',
  v3SubmitErrBtnViewOrderStatus: 'Order Status',
  v3SubmitErrBtnBackStore: 'Back to Shop',
  v3SubmitErrBtnGoUpdate: 'Update',
  v3SubmitErrBtnResubscribe: 'Resubscribe',
  v3SubmitErrTipUpdateApp: 'Update via App Store',
  v3SubmitErrTipRelogin: 'Please log in again',

  v3SubmitErrMsg120009: 'Order processed – check your in-game backpack.',
  v3SubmitErrMsg120003: 'Product info error – please reselect.',
  v3SubmitErrMsg120016: 'Too many requests – wait a few seconds and retry.',
  v3SubmitErrMsg120025: 'Invalid request parameters – please log in again and retry.',
  v3SubmitErrMsg121012: 'Payment channel unavailable – please try another method.',
  v3SubmitErrMsg120012: 'Unstable network – please check your connection and retry.',
  v3SubmitErrMsg120002: 'No game character found – please create one first.',
  v3SubmitErrMsg121019: 'Order info error – please place a new order.',
  v3SubmitErrMsg120024: 'Pre-registration gift already claimed – no need to repeat.',
  v3SubmitErrMsg120000: 'Login expired – please log in again.',
  v3SubmitErrMsg120014: 'Invalid order number – please place a new order.',
  v3SubmitErrMsg121001: 'Recharge failed – please retry later or contact support.',
  v3SubmitErrMsg120015: 'Payment amount error – please reselect the item.',
  v3SubmitErrMsg120001: 'Server mismatch – please switch to the correct server.',
  v3SubmitErrMsg120020: 'Payment channel returned an error – please try another method.',
  v3SubmitErrMsg120010: 'Recharge function is temporarily disabled – please try later.',
  v3SubmitErrMsg120006: 'Amount verification failed – please reselect.',
  v3SubmitErrMsg121010: 'Sandbox recharge request invalid – please use the official version.',
  v3SubmitErrMsg120017: 'Duplicate order number – please check if already paid.',
  v3SubmitErrMsg120022: 'Payment callback verification failed – please retry later.',
  v3SubmitErrMsg121000: 'System busy – please try again later.',
  v3SubmitErrMsg120011: 'Product ID error – please reselect.',
  v3SubmitErrMsg121015: 'Payment amount verification failed – please place a new order.',
  v3SubmitErrMsg120004: 'Payment channel not open – please choose another method.',
  v3SubmitErrMsg120005: 'Payment channel under maintenance – please use another method.',
  v3SubmitErrMsg120007: 'Invalid platform ID – please log in again.',
  v3SubmitErrMsg120008: 'Insufficient request parameters – please resubmit.',
  v3SubmitErrMsg120013: 'Invalid developer order number – please place a new order.',
  v3SubmitErrMsg120018: 'Payment blocked by risk control – please contact support for verification.',
  v3SubmitErrMsg120019: 'Package name verification failed – please use the official version.',
  v3SubmitErrMsg120021: 'Product ID verification failed – please reselect.',
  v3SubmitErrMsg120023: 'Pre-registration gift delivery error – please check later.',
  v3SubmitErrMsg120026: 'Account not found – please check your account status.',
  v3SubmitErrMsg120030: 'Insufficient total stock – please choose another item.',
  v3SubmitErrMsg120031: 'You\'ve exceeded the purchase limit for this item – please adjust.',
  v3SubmitErrMsg120032: 'Game version is too old – please download the latest version.',
  v3SubmitErrMsg120080: 'Agent payment limited by risk control – please use your own payment method.',
  v3SubmitErrMsg120081: 'Agent payment delayed by risk control – please check the result later.',
  v3SubmitErrMsg121002: 'Order cache invalid – please place a new order.',
  v3SubmitErrMsg121003: 'Recharge configuration not found – please contact support.',
  v3SubmitErrMsg121004: 'Insufficient extended parameters – please resubmit.',
  v3SubmitErrMsg121005: 'Cache write failed – please try again later.',
  v3SubmitErrMsg121006: 'Cache read failed – please try again later.',
  v3SubmitErrMsg121007: 'Recharge type configuration error – please contact support.',
  v3SubmitErrMsg121011: 'New fields detected from Apple – please update the app.',
  v3SubmitErrMsg121013: 'Renewal order not found – please resubscribe.',
  v3SubmitErrMsg121014: 'Recharge parameter decryption failed – please resubmit.',
  v3SubmitErrMsg121017: 'This order has been refunded – please contact support for confirmation.',
  v3SubmitErrMsg121018: 'Subscription expired – please resubscribe.',
  v3SubmitErrMsg121020: 'Order cancelled – please place a new order.',
  v3SubmitErrMsg121021: 'Google API error – please try again later.',
  v3SubmitErrMsg121022: 'Failed to get access token – please log in again.',
  v3SubmitErrMsg121023: 'Order status abnormal – please check delivery status.',
  v3SubmitErrMsg121024: 'Order confirmation failed – please try again later.'
};
